// extracted by mini-css-extract-plugin
export default {"StatusOrange":"#EF7C00","SiteOrange":"#EF7C00","Button":"WarningButton_Button__3GXuG"};